import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-alert',
  templateUrl: './icon-alert.component.html',
  styleUrls: ['./icon-alert.component.scss']
})
export class IconAlertComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
